
/**
 * Use this file for JavaScript code that you want to run in the front-end
 * on posts/pages that contain this block.
 */

document.addEventListener('DOMContentLoaded', function() {
	const barryMapBlocks = document.querySelectorAll('.wp-block-bmg-block-barrymap');

	if (barryMapBlocks.length === 0) {
		return;
	}

	// Fetch POI data from REST API
	fetch('/wp-json/barrymap/v1/poi-data')
		.then(response => response.json())
		.then(poiData => {
			barryMapBlocks.forEach(block => {
				initializeBarryMap(block, poiData);
			});
		})
		.catch(error => {
			console.error('Error fetching POI data:', error);
		});
});

function initializeBarryMap(block, poiData) {
	const container = block.querySelector('.barrymap-container');
	if (!container) {
		return;
	}

	// Center the scroll horizontally on load
	function centerScroll() {
		const scrollWidth = container.scrollWidth;
		const clientWidth = container.clientWidth;
		if (scrollWidth > clientWidth) {
			container.scrollLeft = (scrollWidth - clientWidth) / 2;
		}
	}

	// Center scroll after content is loaded
	if (container.scrollWidth > 0) {
		centerScroll();
	} else {
		// Wait for SVG to load
		const svg = container.querySelector('svg');
		if (svg) {
			if (svg.complete) {
				centerScroll();
			} else {
				svg.addEventListener('load', centerScroll, { once: true });
			}
		}
		// Fallback: try after a short delay
		setTimeout(centerScroll, 100);
	}

	// Center scroll on window resize (with debounce)
	let resizeTimeout;
	window.addEventListener('resize', function() {
		clearTimeout(resizeTimeout);
		resizeTimeout = setTimeout(centerScroll, 150);
	});

	// Create tooltip element
	const tooltip = document.createElement('div');
	tooltip.className = 'barrymap-tooltip';
	container.appendChild(tooltip);

	// Find all POI elements
	const poiElements = container.querySelectorAll('[id^="POI_"]');

	poiElements.forEach(element => {
		const poiId = element.getAttribute('id');
		
		// Extract the base POI identifier (remove --2, --3, etc.)
		const basePoi = poiId.replace(/^POI_/, '').replace(/--\d+$/, '');
		
		// Check if we have data for this POI
		const poiTranslations = poiData[basePoi];

		if (poiTranslations) {
			const currentLang = getCurrentLanguage();
			const poiName = typeof poiTranslations === 'string' 
				? poiTranslations 
				: (poiTranslations[currentLang] || poiTranslations['fr'] || Object.values(poiTranslations)[0] || '');
			
			element.addEventListener('mouseenter', function(e) {
				showTooltip(e, tooltip, poiName, container);
			});

			element.addEventListener('mousemove', function(e) {
				updateTooltipPosition(e, tooltip, container);
			});

			element.addEventListener('mouseleave', function() {
				hideTooltip(tooltip);
			});

			element.addEventListener('touchstart', function(e) {
				e.preventDefault();
				const touch = e.touches[0];
				showTooltip({ clientX: touch.clientX, clientY: touch.clientY }, tooltip, poiName, container);
			}, { passive: false });

			element.addEventListener('touchend', function() {
				setTimeout(() => hideTooltip(tooltip), 2000);
			});
		}
	});
}

function showTooltip(event, tooltip, text, container) {
	tooltip.textContent = text;
	tooltip.classList.add('visible');
	updateTooltipPosition(event, tooltip, container);
}

function updateTooltipPosition(event, tooltip, container) {
	const containerRect = container.getBoundingClientRect();
	
	// Calculate position relative to container (accounting for scroll)
	const x = event.clientX - containerRect.left + container.scrollLeft;
	const y = event.clientY - containerRect.top + container.scrollTop;

	// Position tooltip above the cursor/touch point, centered horizontally
	tooltip.style.left = x + 'px';
	tooltip.style.top = (y - tooltip.offsetHeight - 15) + 'px';
	tooltip.style.transform = 'translateX(-50%)';
}

function hideTooltip(tooltip) {
	tooltip.classList.remove('visible');
}

function getCurrentLanguage() {
	return window.currentLang 
		|| document.documentElement.lang?.split('-')[0] 
		|| document.querySelector('meta[name="polylang"]')?.getAttribute('content') 
		|| 'fr';
}
